const apiCall = async (
  endpoint,
  method = 'POST',
  payload,
  msgConfig = {},
  fetchCart = true,
  awaitFetchCart = false,
) => {
  try {
    const response = await fetch(endpoint, {
      method: method,
      headers: { 'Content-Type': 'application/json' },
      body: payload ? JSON.stringify(payload) : null,
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error(`Cart API error in ${msgConfig.action}:`, errorData);
      alert(errorData.message || msgConfig.error);
      return;
    }

    // Refresh the cart
    if (fetchCart && awaitFetchCart) {
      await window.CartDrawer?.fetch?.();
    } else if (fetchCart) {
      window.CartDrawer?.fetch?.();
    }
  } catch (error) {
    console.error(`Cart error in ${msgConfig.action}:`, error);
    alert('An unexpected error occurred. Please try again.');
  }
};

export const cartApi = {
  updateQty: (itemKey, quantity, action, setLoading) => {
    setLoading({ status: true, itemKey, action });

    const payload = { id: String(itemKey), quantity: quantity };
    const msgConfig = {
      action: 'updateQty',
      error: 'An error occurred while updating the cart.',
    };
    apiCall('/cart/change.js', 'POST', payload, msgConfig, true, true).finally(
      () => {
        setLoading(null);
      },
    );
  },

  addToCart: (variantId, quantity = 1, action, setLoading) => {
    setLoading({ status: true, variantId, action });

    const payload = { id: String(variantId), quantity: quantity };
    const msgConfig = {
      action: 'addToCart',
      error: 'An error occurred while adding the product to the cart.',
    };
    apiCall('/cart/add.js', 'POST', payload, msgConfig, true, true).finally(
      () => {
        setLoading(null);
      },
    );
  },

  addFreeGift: (freeGiftVariantId) => {
    const payload = {
      items: [
        {
          id: String(freeGiftVariantId),
          quantity: 1,
          properties: { _is_free_gift: 'true' },
        },
      ],
    };
    const msgConfig = {
      action: 'addFreeGift',
      error: 'An error occurred while adding the free gift.',
    };

    apiCall('/cart/add.js', 'POST', payload, msgConfig);
  },

  removeFreeGift: (lineItems) => {
    const freeGiftItemKey = lineItems.find(
      (item) => item.properties && item.properties._is_free_gift === 'true',
    )?.key;

    if (!freeGiftItemKey) {
      console.log('No free gift found in the cart.');
      return;
    }

    const payload = { id: String(freeGiftItemKey), quantity: 0 };
    const msgConfig = {
      action: 'removeFreeGift',
      error: 'An error occurred while removing the free gift.',
    };
    apiCall('/cart/change.js', 'POST', payload, msgConfig);
  },

  updateSellingPlan: (sellingPlanId, itemKey, quantity, setLoading) => {
    setLoading({ status: true, itemKey, action: 'subscribe' });
    const payload = {
      id: String(itemKey),
      quantity: quantity,
      selling_plan: sellingPlanId,
    };
    const msgConfig = {
      action: 'updateSellingPlan',
      error: 'An error occurred while updating the selling plan.',
    };
    apiCall('/cart/change.js', 'POST', payload, msgConfig, true, true).finally(
      () => {
        setLoading(null);
      },
    );
  },
};
